import React, { useEffect, useState } from "react";
import {
    Card,
    Row,
    Col,
    Badge,
    Carousel,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";

export default function ViewReligiousAffiliation() {
    const { id } = useParams();

    const [affiliation, setAffiliation] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);

    const AuthToken = localStorage.getItem("AuthUser");

    axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

    useEffect(() => {
        fetchAffiliation();
    }, [id]);

    const fetchAffiliation = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/religious-affiliations/${id}`
            );

            setAffiliation(res.data.data);
        } catch (error) {
            console.error("Error fetching religious affiliation:", error);
        }
    };

    /*
    |--------------------------------------------------------------------------
    | Religious Leader Labels
    |--------------------------------------------------------------------------
    */

    const getReligiousLeaderInfo = (faithId) => {
        switch (Number(faithId)) {
            case 1:
                return {
                    title: "Mosque / Religious Leader",
                    nameLabel: "Molvi / Imam Name",
                    contactLabel: "Molvi / Imam Contact Number",
                    icon: "mosque",
                };

            case 2:
                return {
                    title: "Church Information",
                    nameLabel: "Pastor Name",
                    contactLabel: "Pastor Contact Number",
                    icon: "church",
                };

            case 3:
                return {
                    title: "Temple / Religious Leader",
                    nameLabel: "Pandit Name",
                    contactLabel: "Pandit Contact Number",
                    icon: "temple_hindu",
                };

            case 4:
                return {
                    title: "Ahmadi Religious Leader",
                    nameLabel: "Missionary Name",
                    contactLabel: "Missionary Contact Number",
                    icon: "person",
                };

            default:
                return {
                    title: "Religious Leader Information",
                    nameLabel: "Religious Leader Name",
                    contactLabel: "Contact Number",
                    icon: "person",
                };
        }
    };

    if (!affiliation) {
        return (
            <PageLayout>
                <Card>
                    <Card.Body>Loading...</Card.Body>
                </Card>
            </PageLayout>
        );
    }

    const faithId =
        affiliation.place?.faith_id ||
        affiliation.faith_id ||
        affiliation.place?.faith?.id;

    const leaderInfo = getReligiousLeaderInfo(faithId);

    /*
    |--------------------------------------------------------------------------
    | Video URL
    |--------------------------------------------------------------------------
    */

    const getVideoUrl = (video) => {
        if (!video) return "";

        if (
            video.startsWith("http://") ||
            video.startsWith("https://")
        ) {
            return video;
        }

        return `${process.env.REACT_APP_IMG_URL}/${video}`;
    };

    /*
    |--------------------------------------------------------------------------
    | Image URL
    |--------------------------------------------------------------------------
    */

    const getImageUrl = (image) => {
        if (!image) return "";

        if (
            image.startsWith("http://") ||
            image.startsWith("https://")
        ) {
            return image;
        }

        return `${process.env.REACT_APP_IMG_URL}${image}`;
    };

    return (
        <PageLayout>
            <Card>
                <Card.Header>
                    <h5 className="mb-0">
                        Religious Affiliation Details
                    </h5>
                </Card.Header>

                <Card.Body>

                    {/* =====================================================
                        BENEFICIARY INFORMATION
                    ====================================================== */}

                    <Card className="border mb-4 shadow-sm">
                        <Card.Header className="bg-light">
                            <h6 className="mb-0">
                                <i className="material-icons me-2">
                                    person
                                </i>
                                Beneficiary Information
                            </h6>
                        </Card.Header>

                        <Card.Body>
                            <Row>

                                <Col md={6} className="mb-3">
                                    <div className="text-muted small">
                                        Family Number
                                    </div>

                                    <div className="fw-semibold">
                                        {affiliation.person?.f_number || "-"}
                                    </div>
                                </Col>

                                <Col md={6} className="mb-3">
                                    <div className="text-muted small">
                                        Beneficiary Name
                                    </div>

                                    <div className="fw-semibold">
                                        {affiliation.person?.beneficiary_name || "-"}
                                    </div>
                                </Col>

                                <Col md={6} className="mb-3">
                                    <div className="text-muted small">
                                        Faith
                                    </div>

                                    <div className="fw-semibold">
                                        {affiliation.place?.faith?.name ||
                                            affiliation.faith?.name ||
                                            "-"}
                                    </div>
                                </Col>

                            </Row>
                        </Card.Body>
                    </Card>


                    {/* =====================================================
                        PRAYER PLACE INFORMATION
                    ====================================================== */}

                    <Card className="border mb-4 shadow-sm">

                        <Card.Header className="bg-light">
                            <h6 className="mb-0">
                                <i className="material-icons me-2">
                                    place
                                </i>

                                {leaderInfo.title}
                            </h6>
                        </Card.Header>

                        <Card.Body>

                            <Row>

                                {/* Prayer Place */}

                                <Col md={6} className="mb-3">

                                    <div className="text-muted small">
                                        Prayer Place
                                    </div>

                                    <div className="fw-semibold">
                                        {affiliation.place?.palace_name || "-"}
                                    </div>

                                </Col>


                                {/* Dynamic Religious Leader Name */}

                                <Col md={6} className="mb-3">

                                    <div className="text-muted small">
                                        {leaderInfo.nameLabel}
                                    </div>

                                    <div className="fw-semibold">
                                        {affiliation.place?.master || "-"}
                                    </div>

                                </Col>


                                {/* Dynamic Contact */}

                                <Col md={6} className="mb-3">

                                    <div className="text-muted small">
                                        {leaderInfo.contactLabel}
                                    </div>

                                    <div className="fw-semibold">
                                        {affiliation.place?.phone ||
                                            affiliation.place?.contact ||
                                            "-"}
                                    </div>

                                </Col>


                                {/* Address */}

                                <Col md={12} className="mb-2">

                                    <div className="text-muted small">
                                        Address
                                    </div>

                                    <div className="border rounded p-3 bg-light">
                                        {affiliation.place?.address || "-"}
                                    </div>

                                </Col>

                            </Row>

                        </Card.Body>

                    </Card>


                    {/* =====================================================
                        CHRISTIAN / CHURCH DETAILS
                    ====================================================== */}

                    {Number(faithId) === 2 && (

                        <Card className="border mb-4 shadow-sm">

                            <Card.Header className="bg-light">

                                <h6 className="mb-0">

                                    <i className="material-icons me-2">
                                        church
                                    </i>

                                    Church Engagement Details

                                </h6>

                            </Card.Header>


                            <Card.Body>

                                <Row>

                                    {/* Baptized */}

                                    <Col md={6} className="mb-3">

                                        <div className="text-muted small mb-1">
                                            Baptized
                                        </div>

                                        {Number(affiliation.baptized) === 1 ? (

                                            <Badge bg="success">
                                                Yes
                                            </Badge>

                                        ) : Number(affiliation.baptized) === 2 ? (

                                            <Badge bg="info">
                                                By PPI
                                            </Badge>

                                        ) : (

                                            <Badge bg="secondary">
                                                No
                                            </Badge>

                                        )}

                                    </Col>


                                    {/* Church Engagement Date */}

                                    <Col md={6} className="mb-3">

                                        <div className="text-muted small">
                                            Date of Church Engagement
                                        </div>

                                        <div className="fw-semibold">
                                            {affiliation.date_of_church_engagement ||
                                                "-"}
                                        </div>

                                    </Col>

                                </Row>

                            </Card.Body>

                        </Card>

                    )}


                    {/* =====================================================
                        COMMENTS
                    ====================================================== */}

                    <Card className="border mb-4 shadow-sm">

                        <Card.Header className="bg-light">

                            <h6 className="mb-0">

                                <i className="material-icons me-2">
                                    comment
                                </i>

                                Comments / Additional Information

                            </h6>

                        </Card.Header>


                        <Card.Body>

                            <div
                                className="border rounded p-3"
                                style={{
                                    minHeight: "80px",
                                    backgroundColor: "#fafafa",
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {affiliation.comments ||
                                    "No comments available."}
                            </div>

                        </Card.Body>

                    </Card>


                    {/* =====================================================
                        PICTURE GALLERY
                    ====================================================== */}

                    {affiliation?.images?.length > 0 && (

                        <Card className="border mb-4 shadow-sm">

                            <Card.Header className="bg-light">

                                <h6 className="mb-0">

                                    <i className="material-icons me-2">
                                        photo_library
                                    </i>

                                    Picture Gallery

                                    <Badge
                                        bg="secondary"
                                        className="ms-2"
                                    >
                                        {affiliation.images.length}
                                    </Badge>

                                </h6>

                            </Card.Header>


                            <Card.Body>

                                <Carousel
                                    activeIndex={activeIndex}
                                    onSelect={(selectedIndex) =>
                                        setActiveIndex(selectedIndex)
                                    }
                                    interval={null}
                                >

                                    {affiliation.images.map((item) => (

                                        <Carousel.Item key={item.id}>

                                            <img
                                                src={getImageUrl(item.img)}
                                                className="d-block w-100"
                                                style={{
                                                    height: "450px",
                                                    objectFit: "contain",
                                                    background: "#f8f9fa",
                                                }}
                                                alt="Religious affiliation"
                                            />

                                        </Carousel.Item>

                                    ))}

                                </Carousel>


                                {/* Thumbnails */}

                                <div
                                    className="d-flex gap-2 mt-3 flex-wrap justify-content-center"
                                >

                                    {affiliation.images.map(
                                        (item, index) => (

                                            <img
                                                key={item.id}
                                                src={getImageUrl(item.img)}
                                                alt="Thumbnail"
                                                onClick={() =>
                                                    setActiveIndex(index)
                                                }
                                                style={{
                                                    width: "75px",
                                                    height: "75px",
                                                    objectFit: "cover",
                                                    cursor: "pointer",
                                                    border:
                                                        activeIndex === index
                                                            ? "3px solid #0d6efd"
                                                            : "1px solid #ddd",
                                                    borderRadius: "6px",
                                                }}
                                            />

                                        )
                                    )}

                                </div>

                            </Card.Body>

                        </Card>

                    )}


                    {/* =====================================================
                        VIDEO
                    ====================================================== */}

                    {affiliation.video_link && (

                        <Card className="border mb-4 shadow-sm">

                            <Card.Header className="bg-light">

                                <h6 className="mb-0">

                                    <i className="material-icons me-2">
                                        video_library
                                    </i>

                                    Religious Affiliation Video

                                </h6>

                            </Card.Header>


                            <Card.Body>

                                <div
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        paddingTop: "56.25%",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        background: "#000",
                                    }}
                                >

                                    <video
                                        controls
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                        }}
                                    >

                                        <source
                                            src={getVideoUrl(
                                                affiliation.video_link
                                            )}
                                            type="video/mp4"
                                        />

                                        Your browser does not support the video
                                        tag.

                                    </video>

                                </div>

                            </Card.Body>

                        </Card>

                    )}

                </Card.Body>
            </Card>
        </PageLayout>
    );
}